









import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ChoiceCheckBox from '@/views/organisms/ChoiceCheckBox.vue'
import ApiClient from '@/common/api'
import store from '@/store'

export default
  components: {
    Popup
    BlueButton
    ChoiceCheckBox
    
  }

  data: () ->
    saveNum: 0

  props:
    list:
      type: Array
      default: []
    title:
      type: String
      default: ''
    name:
      type: String
      default: ''
    id:
      type: String
      default: ''
    defaultNum: 
      type: String
      default: ''

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_click: () ->
      api = new ApiClient()
      param = 
        id: @id
        [@name]: store.getters.getPostParam[@name]
      data = await api.post('/fc/save', param)
      store.getters.getPostParam
      if data.errors.length == 0
        @$emit('click')
  }
